import { render, staticRenderFns } from "./textbox-template.vue?vue&type=template&id=416caace&"
import script from "./textbox-template.vue?vue&type=script&lang=js&"
export * from "./textbox-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports